/**
 * SingleVariantPriceHandler
 *
 * Description: Gère la mise à jour automatique des prix en fonction de la quantité sélectionnée
 * pour les produits ayant un seul variant (product.has_only_default_variant = true).
 *
 * Fonctionnalité:
 * - Détecte automatiquement les produits avec un seul variant
 * - Parse les données de prix multipliés depuis [data-single-variant-price-list]
 * - Met à jour tous les éléments de prix ([data-price-style]) en temps réel
 * - Met à jour les aria-labels des boutons "Add to cart" pour l'accessibilité
 *
 * Utilisation: S'initialise automatiquement au chargement de la page (DOMContentLoaded)
 */
export default class SingleVariantPriceHandler {
	constructor() {
		this.init();
	}

	init() {
		// Vérifier s'il y a un script de prix pour produit avec un seul variant
		const priceListElement = document.querySelector(
			'[data-single-variant-price-list]',
		);
		if (!priceListElement) return;

		this.pricelist = JSON.parse(priceListElement.textContent);
		this.variantId = Object.keys(this.pricelist)[0];

		this.setupQuantityListeners();
	}

	setupQuantityListeners() {
		// Sélectionner tous les selects de quantité
		const quantitySelects = document.querySelectorAll(
			'select[name="quantity"].select-main',
		);

		quantitySelects.forEach((select) => {
			select.addEventListener('change', (e) => {
				this.updatePrices(e.target.value);
			});
		});
	}

	updatePrices(quantity) {
		const price = this.pricelist[this.variantId][quantity];

		// Mettre à jour tous les éléments de prix
		const priceElements = document.querySelectorAll('[data-price-style]');
		priceElements.forEach((element) => {
			element.innerText = price;
		});

		// Mettre à jour les aria-labels des boutons
		const addButtons = document.querySelectorAll('button[name="add"]');
		const ariaLabel = `${
			window.variantStrings?.addToCart || 'Add to cart'
		} - ${price}`;
		addButtons.forEach((button) => {
			button.ariaLabel = ariaLabel;
		});
	}
}
